import { mockMediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            PV预告、漫画家访谈、作品混剪 — 漫画之外同样精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mockMediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group cursor-pointer"
            >
              <div className="relative aspect-video rounded-xl overflow-hidden bg-background-100 border border-background-200/70 group-hover:border-primary-200 transition-all duration-300 mb-3">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 text-[10px] font-medium bg-background-50/90 text-foreground-700 rounded whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="inline-flex items-center gap-1 text-[10px] text-background-50 bg-black/50 px-2 py-0.5 rounded whitespace-nowrap">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1 line-clamp-2 leading-snug">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}